import * as React from 'react';
export const generateDotMarker = (id) => (React.createElement("marker", { id: id, name: "dot", viewBox: "0 0 6 6", refX: "3", refY: "3", markerWidth: "3", markerHeight: "3", orient: "auto" },
    React.createElement("circle", { r: "3", cx: "3", cy: "3" })));
